import React from 'react';

const MARK_HEIGHTS = { lg: 40, md: 32, sm: 24 };

/**
 * Логотип «№ ЛИМИТЕК»
 * props:
 *  - size: 'lg' | 'md' | 'sm' | число (высота знака в px)
 *  - showWord: показывать словесную часть «ЛИМИТЕК»
 *  - color: цвет (по умолчанию белый из палитры)
 */
export default function Logo({
  size = 'lg',
  showWord = true,
  color = 'var(--color-white-100, #EFEFEF)',
  className = '',
  style,
}) {
  const markH = typeof size === 'number' ? size : MARK_HEIGHTS[size] || MARK_HEIGHTS.lg;
  const gap = markH >= 40 ? 16 : 8;
  const wordSize = Math.round(markH * 0.5);
  const markSize = Math.round(markH * 0.72);

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        color,
        ...style,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontWeight: 600,
          fontSize: markSize,
          lineHeight: 1,
          letterSpacing: '0.02em',
          color: 'currentColor',
        }}
      >
        №
      </span>
      {showWord && (
        <span
          style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontWeight: 600,
            fontSize: wordSize,
            lineHeight: '100%',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'currentColor',
          }}
        >
          ЛИМИТЕК
        </span>
      )}
    </span>
  );
}
